import { securedFetch } from "../auth/authService";
import { LOG_API, SYSTEM_SETTINGS_API } from "../vars";
import { getDateInLogFormat } from "../utils";
import fileDownload from 'js-file-download';

// export function getLogs(fromSource, lines, date, deviceIp) {
//     return securedFetch(LOG_API, {
//         from: fromSource,
//         lines,
//         date: getDateInLogFormat(date),
//         deviceIp: deviceIp
//     }).then(response => response.json());
// }

export function getLogs(fromSource, lines, date, deviceIp, keyword) {
    return securedFetch(LOG_API, {
        from: fromSource,
        lines,
        date: getDateInLogFormat(date),
        deviceIp: deviceIp,
        keyword: keyword
    }).then(response => response.json());
}

export async function getAvailableDates() {
    const payload = await securedFetch(`${LOG_API}/dates`).then(response => response.json());
    const app = payload.app.map(dateString => new Date(dateString));
    const syslog = payload.syslog.map(dateString => new Date(dateString));
    return { app, syslog };
}

export function downloadFile(date, fromSource, deviceIp, connectionType) {
    const formattedDate = getDateInLogFormat(date)
    //const accessToken = localStorage.getItem('access_token');
    const accessToken = sessionStorage.getItem('access_token');
    fetch(`${LOG_API}/download?date=${formattedDate}&from=${fromSource}&deviceIp=${deviceIp}&connectionType=${connectionType}&_ticket=${accessToken}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'text/plain'
        }
    }).then(async res => {
        const text = await res.text();
        fileDownload(text, `${formattedDate}.log`);
    })
}

//Added byOctopus DevTeam November 23,2022
export async function saveDebugMode(debugMode) {
    //alert(debugMode);
    const systemSettings = {
        name: 'debugMode',
        value: debugMode + "",
        type: '',
        note: ''
    }

    return await securedFetch(`${SYSTEM_SETTINGS_API}/saveDebugMode`, systemSettings, 'POST')
        .then((response => response.json()));
}


export async function getDebugMode() {
    return securedFetch(`${SYSTEM_SETTINGS_API}/getDebugMode`, '', 'GET')
        .then(response => response.json())
        .then(data => {
            return data;
        })
}   
